export function InternalLink(url, target) {
  return { internal: true, url, target }
}

export function ExternalLink(url, target) {
  return { internal: false, url, target }
}
